import React, { useState, useEffect, useRef } from "react";

import "./EcommerceCheckout.scss"
import CheckoutItem from "./CheckoutItem/CheckoutItem";
import Header from "../../components/Header/Header";
import InputComponent from "../../components/InputComponent/InputComponent";
import Checkbox from "../../components/Checkbox/Checkbox";
import PaymentComponent from "../../components/PaymentComponent/PaymentComponent";
import RadioButton from "../../components/RadioButton/RadioButton";
import Button from "../../components/Button/Button";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import EcommercePayment from "./EcommercePayment/EcommercePayment";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
const EcommerceCheckout = () => {
    const history = useHistory()
    const companyDetails = useSelector((state) => state.companyData.company)
    const settingsCompany = useSelector((state) => state.companyData.settings)

    const cart = useSelector((state) => state.companyData.cart)
    const adyenRef = useRef(null);

    let parsedUserDetails = localStorage.getItem('fullUserDetails') && JSON.parse(localStorage.getItem('fullUserDetails'))
    const address = parsedUserDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Billing") : null
    const addressDelivery = parsedUserDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Delivery") : null

    const [isSame, setIsSame] = useState(false);
    const [subOrderTypes, setSubOrderTypes] = useState([]);



    const [contactDetails, setContactDetails] = useState({
        firstName: parsedUserDetails ? parsedUserDetails.FirstName : "",
        lastName: parsedUserDetails ? parsedUserDetails.LastName : "",
        email: parsedUserDetails ? parsedUserDetails.Email : "",
        phoneNumber: address ? address.Phone : ""
    })
    const [deliveryDetails, setDeliveryDetails] = useState({
        address1: addressDelivery?.AddressLine1 || "",
        address2: addressDelivery?.AddressLine2 || "",
        city: addressDelivery?.City || "",
        state: addressDelivery?.StateProvinceRegion || "",
        country: addressDelivery?.Country || 'United Kingdom',
        postal: addressDelivery?.PostZipCode || ""
    })
    const [billingDetails, setBillingDetails] = useState({
        address1: address ? address?.AddressLine1 : "",
        address2: address ? address?.AddressLine2 : "",
        city: address ? address?.City : "",
        state: address ? address?.StateProvinceRegion : "",
        country: address ? address?.Country : 'United Kingdom',
        postal: address ? address?.PostZipCode : ""
    })
    const [selectedValue, setSelectedValue] = useState("CASH");
    const [selectedTypeValue, setSelectedTypeValue] = useState(subOrderTypes[0]?.SubOrderTypeName || "");
    const [avalaiblePaymentTypes, setAvalablePaymentTypes] = useState(subOrderTypes[0]?.AvailablePaymentTypes || []);



    const handleChange = (value) => {
        setSelectedValue(value.toUpperCase());
    };
    const handleTypeChange = (value) => {
        let type = subOrderTypes.find((order) => order.SubOrderTypeName === value)
        setAvalablePaymentTypes(type)
        setSelectedValue(type[0]?.toUpperCase())
        setSelectedTypeValue(value);
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        let settings = localStorage.getItem("ECOM_SETTINGS") && JSON.parse(localStorage.getItem("ECOM_SETTINGS")) || [];
        let orgID = companyDetails.OrganisationID
        const types = settings.find((setting) => (setting.OrgID === orgID)) ? settings.find((setting) => (setting.OrgID === orgID))?.SubOrderTypes : []
        const orderTypes = types.filter((type) => type.IsActive)
        setSubOrderTypes(orderTypes)
        setSelectedTypeValue(orderTypes[0]?.SubOrderTypeName);
        setAvalablePaymentTypes(orderTypes[0]?.AvailablePaymentTypes)
        setSelectedValue(orderTypes[0]?.AvailablePaymentTypes[0]?.toUpperCase())

    }, [])
    const onContactDetailsChange = (e, field) => {
        setContactDetails({ ...contactDetails, [field]: e.target.value })
    }
    const onDeliveryDetailsChange = (e, field) => {
        setDeliveryDetails({ ...deliveryDetails, [field]: e.target.value })
    }
    const onBillingDetailsChange = (e, field) => {
        setBillingDetails({ ...billingDetails, [field]: e.target.value })
    }
    const handleCheckboxChange = () => {
        setIsSame(!isSame);
        if (!isSame) {
            setBillingDetails(deliveryDetails)
        } else {
            setBillingDetails({
                address1: address ? address?.AddressLine1 : "",
                address2: address ? address?.AddressLine2 : "",
                city: address ? address?.City : "",
                state: address ? address?.StateProvinceRegion : "",
                country: 'United Kingdom',
                postal: address ? address?.PostZipCode : ""
            })
        }
    };
    const handleLogout = () => {
        sessionStorage.clear()
        localStorage.clear()
        history.push("/")
    };
    const getTotalPrice = () => {
        const total = cart.reduce((sum, item) => {
            const qty = item.ProductQty || 0;
            const price = item.ProductPrice || 0;
            return sum + qty * price;
        }, 0);
        return total.toFixed(2);
    };
    const getCustomerDetails = () => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
        const customerFormData = {
            ID: userId,
            Name: {
                DisplayName: contactDetails.firstName,
                FirstName: contactDetails.firstName,
                LastName: contactDetails.lastName
            },
            Email: contactDetails.email.trim(),
            Contact: {
                Number: contactDetails.phoneNumber,
                PinCode: "+44",
                CountryISO2: "GB",
            },
            BillingAddress: {
                Id: "",
                AddressType: "",
                AddressLine1: billingDetails.address1,
                AddressLine2: billingDetails.address2,
                StateProvinceRegion: billingDetails.state,
                PostZipCode: billingDetails.postal,
                Country: billingDetails.country,
                City: billingDetails.city,
                CountryCode: "",
                AddressLabel: "",
                Longitude: 0,
                Latitude: 0,
                Additional: {
                    Instruction: "",
                    InteractionType: "",
                },
            },
            DeliveryAddress: {
                Id: "",
                AddressType: "",
                AddressLine1: deliveryDetails.address1,
                AddressLine2: deliveryDetails.address2,
                StateProvinceRegion: deliveryDetails.state,
                PostZipCode: deliveryDetails.postal,
                Country: deliveryDetails.country,
                City: deliveryDetails.city,
                CountryCode: "",
                AddressLabel: "",
                Longitude: 0,
                Latitude: 0,
                Additional: {
                    Instruction: "",
                    InteractionType: "",
                },
            },
        };
        return customerFormData
    }
    const handlePayClick = () => {
        if (adyenRef.current) {
            adyenRef.current.submit();
        }
    };
    return (
        <div className="EcommerceCheckout">
            <div className="EcommerceCheckout-Navbar" >
                <img alt="" className="logo-container" src={companyDetails?.Logo}
                    onClick={() => {
                        history.push("/")
                    }}
                />

            </div>
            <div className="EcommerceCheckout-Container">
                <div className="EcommerceCheckout-Container-left">
                    <div className="EcommerceCheckout-container-content">
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Contact"} fontSize={"24px"} />
                                {localStorage.getItem('isLogged') === 'true' ?
                                    <div className="login-text" onClick={() => {
                                        handleLogout()
                                    }}>Logout</div> :
                                    <div className="login-text" onClick={() => {
                                        history.push("/account/login")
                                    }}>Login</div>}
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="First Name"
                                    value={contactDetails.firstName}
                                    onChange={e => onContactDetailsChange(e, "firstName")}
                                    required
                                    disabled={localStorage.getItem('isLogged') === 'true'}
                                />
                                <InputComponent layout="layout2"
                                    placeholder="Last Name"
                                    value={contactDetails.lastName}
                                    onChange={e => onContactDetailsChange(e, "lastName")}
                                    required
                                    disabled={localStorage.getItem('isLogged') === 'true'}
                                />
                            </div>
                            <div className="input-container">
                                <InputComponent layout="layout2" placeholder="Email" value={contactDetails.email} onChange={e => onContactDetailsChange(e, "email")}
                                    required
                                    disabled={localStorage.getItem('isLogged') === 'true'}
                                />
                            </div>
                            <div className="input-container">
                                <InputComponent layout="layout2" placeholder="Phone Number" value={contactDetails.phoneNumber} onChange={e => onContactDetailsChange(e, "phoneNumber")} type="number"
                                    required />
                            </div>


                        </div>
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Delivery"} fontSize={"24px"} />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 1"
                                    value={deliveryDetails.address1}
                                    onChange={e => onDeliveryDetailsChange(e, "address1")}
                                    required />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 2"
                                    value={deliveryDetails.address2}
                                    onChange={e => onDeliveryDetailsChange(e, "address2")} />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="City"
                                    value={deliveryDetails.city}
                                    onChange={e => onDeliveryDetailsChange(e, "city")}
                                    required />
                                <InputComponent layout="layout2"
                                    placeholder="State"
                                    value={deliveryDetails.state}
                                    onChange={e => onDeliveryDetailsChange(e, "state")}
                                    required />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="Postal"
                                    value={deliveryDetails.postal}
                                    onChange={e => onDeliveryDetailsChange(e, "postal")}
                                    required />
                                <InputComponent layout="layout2"
                                    placeholder="Country"
                                    value={deliveryDetails.country}
                                    onChange={e => onDeliveryDetailsChange(e, "country")}
                                    required
                                    disabled />
                            </div>
                            <div className="input-container">
                                <Checkbox
                                    label="Same as shipping address"
                                    checked={isSame}
                                    onChange={handleCheckboxChange}
                                />
                            </div>

                        </div>
                        {!isSame && <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Billing Address"} fontSize={"24px"} />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 1"
                                    value={billingDetails.address1}
                                    onChange={e => onBillingDetailsChange(e, "address1")}
                                    required />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 2"
                                    value={billingDetails.address2}
                                    onChange={e => onBillingDetailsChange(e, "address2")} />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="City"
                                    value={billingDetails.city}
                                    onChange={e => onBillingDetailsChange(e, "city")}
                                    required />
                                <InputComponent layout="layout2"
                                    placeholder="State"
                                    value={billingDetails.state}
                                    onChange={e => onBillingDetailsChange(e, "state")}
                                    required />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="Postal"
                                    value={billingDetails.postal}
                                    onChange={e => onBillingDetailsChange(e, "postal")}
                                    required />
                                <InputComponent layout="layout2"
                                    placeholder="Country"
                                    value={billingDetails.country}
                                    onChange={e => onBillingDetailsChange(e, "country")}
                                    required
                                    disabled />
                            </div>

                        </div>}
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Order Type"} fontSize={"24px"} />
                            </div>
                            <div className="input-container-accrodion">
                                {subOrderTypes.map((ordertype, key) => {
                                    return (
                                        <div className="accrodion-top" key={key}>
                                            <RadioButton
                                                name="order-type-options"
                                                value={ordertype.SubOrderTypeName}
                                                checked={selectedTypeValue === ordertype.SubOrderTypeName}
                                                onChange={handleTypeChange}
                                                label={ordertype.SubOrderTypeName}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Payment"} fontSize={"24px"} />
                            </div>
                            <div className="input-container-accrodion">
                                {avalaiblePaymentTypes?.map((type, key) => {
                                    return (
                                        <div className="accrodion-top" key={key}>
                                            <RadioButton
                                                name="payment-options"
                                                value={type.toUpperCase()}
                                                checked={selectedValue === type.toUpperCase()}
                                                onChange={handleChange}
                                                label={type === "Cash" ? "Cash on Delivery (COD)" : "Card"}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="Eccomerce-btn-container">
                            <Button text={"Complete Order"} width={"inherit"} />
                        </div>
                    </div>
                </div>
                <div className="EcommerceCheckout-Container-right">
                    <div className="EcommerceCheckout-container-content">
                        <div className="header-container">
                            <Header text={"Order Summary"} fontSize={"24px"} />
                        </div>
                        {cart.map((product, key) => {
                            return (
                                <CheckoutItem item={product} key={key} />
                            )
                        })}
                        <div className="EcommerceCheckout-container-total">
                            <div className="total-container">
                                <div>Subtotal</div>
                                <div>£ {getTotalPrice()}</div>
                            </div>
                            {/* <div className="total-container">
                                <div>Shipping</div>
                                <div>£ 20.00</div>
                            </div> */}
                            <div className="value-container">
                                <div>Total</div>
                                <div>£ {(parseFloat(getTotalPrice())).toFixed(2)}</div>
                            </div>
                            {selectedValue === "CARD" &&
                                <EcommercePayment
                                    ref={adyenRef}
                                    customerDetails={
                                        getCustomerDetails()
                                    }
                                    total={getTotalPrice()}
                                />
                            }
                            <div className="Eccomerce-btn-container">
                                <Button text={"Complete Order"} width={"inherit"} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )

}
export default EcommerceCheckout